import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';

import { form as formStyle } from '@/styles';

const DescriptionRow = ({ publication }) => {
  const { PublicationTitle, PublicationDescription } = publication;

  return (
    <div css={formStyle.gridContainer}>
      <div>{PublicationTitle}</div>
      <div>{PublicationDescription}</div>
    </div>
  );
};

DescriptionRow.propTypes = {
  publication: PropTypes.object.isRequired,
};

export default DescriptionRow;
